import React from 'react';
import { Box, Button, Typography } from '@mui/material';
import Timeline from '@mui/lab/Timeline';
import TimelineItem from '@mui/lab/TimelineItem';
import TimelineSeparator from '@mui/lab/TimelineSeparator';
import TimelineConnector from '@mui/lab/TimelineConnector';
import TimelineContent from '@mui/lab/TimelineContent';
import TimelineDot from '@mui/lab/TimelineDot';
import TimelineOppositeContent, {
  timelineOppositeContentClasses
} from '@mui/lab/TimelineOppositeContent';
import palette from 'src/theme/palette';
import dayjs from 'dayjs';
import { AlignHorizontalCenter } from '@mui/icons-material';

export default function TimeLineModal({ timelinelist, handleClose }) {
  return (
    <Box flexDirection={'column'} display={'flex'} flex={1}>
      <Box
        pt={1}
        pb={1}
        style={{
          backgroundColor: 'white',
          position: 'sticky',
          top: 0,
          borderBottom: '2px solid',
          borderColor: palette.primary.main,
          zIndex: 5,
          flexDirection: 'row',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center'
        }}
      >
        <Typography variant="h6" gutterBottom textAlign={'flex-start'} mt={2} ml={3}>
          Order Timeline
        </Typography>
        <Button
          onClick={handleClose}
          variant="outlined"
          size="small"
          sx={{ marginRight: 3, height: 40 }}
        >
          Close
        </Button>
      </Box>
      <Box mt={3} />
      <Timeline
        sx={{
          [`& .${timelineOppositeContentClasses.root}`]: {
            flex: 0.2
          }
        }}
      >
        {timelinelist.order_timeline.map((item, index) => (
          <>
            <TimelineItem>
              <TimelineOppositeContent color="text.secondary">
                {dayjs(item?.updated_at).format('h:mm A') || 'N/A'}
              </TimelineOppositeContent>
              <TimelineSeparator>
                <TimelineDot color="primary" />
                {index + 1 !== timelinelist?.order_timeline?.length && (
                  <TimelineConnector sx={{ backgroundColor: palette.primary.main }} />
                )}
              </TimelineSeparator>
              <TimelineContent style={{ textTransform: 'capitalize' }}>
                {item?.remarks}
                {'\t'} ({item?.status})
              </TimelineContent>
            </TimelineItem>
          </>
        ))}
      </Timeline>
    </Box>
  );
}
